// import React from 'react';
// import { ListItem, ListItemText } from 'material-ui/List';

const DeliveryFinishedItem = ({ data }) => {
    // const payload = data.payload || {};
    // const customer = payload.customer || {};
    // const address_data = customer.address || {};
    // const address = `${address_data.address}, ${address_data.district}, ${address_data.city} - ${address_data.state}`;

    return null;

    /* return (
        <ListItem>
            <i className="material-icons" style={{color: 'green'}}>local_shipping</i>
            <ListItemText primary={`Finalizou entrega para ${customer.name}`} secondary={address} />
        </ListItem>
    ); */

}

export default DeliveryFinishedItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Delivery/Finished.js